// extracted by mini-css-extract-plugin
module.exports = {"notationsContainer":"styles_notationsContainer__3xm8K","great":"styles_great___494o"};